// TravelIntroSection.jsx
import React from 'react';
import { 
  FaUmbrellaBeach, 
  FaMonument, 
  FaCity, 
  FaMountain,
  FaArrowRight,
  FaCompass,
  FaMapMarkedAlt,
  FaGlobeAsia
} from 'react-icons/fa';
import '../style.css';

const TravelSection = () => {
  return (
    <section className="travel-intro-section">
      <div className="intro-container">
        {/* Left Content Side */}
        <div className="intro-left">
          <div className="left-content">
            <div className="company-tag">
              <div className="tag-icon">
                <FaCompass />
              </div>
              <span className="tag-text">Premier Travel Agency</span>
            </div>
            
            <h1 className="main-heading">
              <span className="heading-line-1">Shree Balaji</span>
              <span className="heading-line-2">Travel </span>
            </h1>
            
            <div className="highlight-box">
              <div className="highlight-icon">
                <FaGlobeAsia />
              </div>
              <p className="highlight-text">
                Are you ready to embark on the adventure of a lifetime?
              </p>
            </div>
            
            <div className="description-box">
              <p className="description">
                Whether you're dreaming of relaxing on a tropical beach, discovering ancient ruins, 
                or experiencing vibrant city life, we are here to make your travel dreams come true. 
                Our website offers a wide range of tours and travel packages to help you explore 
                the world with ease and excitement.
              </p>
            </div>
            
            <div className="stats-grid">
              <div className="stat-item">
                <div className="stat-number">500+</div>
                <div className="stat-label">Tours</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">Destinations</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">10k+</div>
                <div className="stat-label">Travelers</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">98%</div>
                <div className="stat-label">Satisfaction</div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Right Content Side */}
        <div className="intro-right">
          <div className="right-content">
            <div className="services-title">
              <h2>Our Services</h2>
              <div className="title-underline"></div>
            </div>
            
            <div className="services-grid">
              <div className="service-card">
                <div className="service-icon-wrapper">
                  <FaUmbrellaBeach className="service-icon" />
                </div>
                <h3 className="service-title">Beach Holidays</h3>
                <p className="service-desc">Tropical paradise getaways</p>
                <div className="service-hover">
                  <span>Explore</span>
                  <FaArrowRight />
                </div>
              </div>
              
              <div className="service-card">
                <div className="service-icon-wrapper">
                  <FaMonument className="service-icon" />
                </div>
                <h3 className="service-title">Heritage Tours</h3>
                <p className="service-desc">Ancient civilization exploration</p>
                <div className="service-hover">
                  <span>Discover</span>
                  <FaArrowRight />
                </div>
              </div>
              
              <div className="service-card">
                <div className="service-icon-wrapper">
                  <FaCity className="service-icon" />
                </div>
                <h3 className="service-title">City Adventures</h3>
                <p className="service-desc">Urban lifestyle experiences</p>
                <div className="service-hover">
                  <span>Experience</span>
                  <FaArrowRight />
                </div>
              </div>
              
              <div className="service-card">
                <div className="service-icon-wrapper">
                  <FaMountain className="service-icon" />
                </div>
                <h3 className="service-title">Mountain Treks</h3>
                <p className="service-desc">Majestic peak expeditions</p>
                <div className="service-hover">
                  <span>Conquer</span>
                  <FaArrowRight />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TravelSection;